import React from 'react';
import { isNil } from 'rambda';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../useStore';
import { useInventorizeStepsStore } from '../../components/store';
import { Button } from '../../../../components/Button/Button';
import { MapStepFooter as messages } from './messages';

export const MapStepFooter: React.VFC = () => {
  const { commodity, newMeter, lat, lng } = useStore();
  const { setPreviousStep } = useInventorizeStepsStore();

  return (
    <>
      <Button block style={{ marginRight: 15 }} type="default" onClick={() => setPreviousStep({ commodity, newMeter })}>
        <FormattedMessage {...messages.back} />
      </Button>
      <Button
        key="submit"
        block
        disabled={isNil(lat) || isNil(lng)}
        form="mapStepForm"
        htmlType="submit"
        type="primary"
      >
        <FormattedMessage {...messages.confirmLocation} />
      </Button>
    </>
  );
};
